var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[(_vm.loggedIn)?[_c('Navbar')]:_vm._e(),_c('router-view'),(_vm.loggedIn)?[_c('Foot')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }